import script from "./RadioForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./RadioForm.vue?vue&type=script&setup=true&lang=ts"

import "./RadioForm.vue?vue&type=style&index=0&id=e8f81e1e&lang=css"

const __exports__ = script;

export default __exports__